import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/retail-app/banner-retail.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service healthcare_banner android_banner chatbot_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={9} lg={8} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                Retail App Development Company
              </h1>
              <span>
                High-Performance,{" "}
                <span style={{ color: "#f47a14" }}>Custom Retail</span> Apps
              </span>
              <p style={{ marginTop: "10px" }}>
                Upgrade your retail business with custom apps designed to
                streamline operations and boost sales. TekRevol builds scalable,
                high-performance apps using React Native and Flutter, tailored
                for seamless inventory sync, AI-driven recommendations, and
                secure payment processing.
              </p>

              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Build My Retail App
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
